
import Vue from 'vue'
import store from '@/store'
const plugin = {
  install(Vue, option) {
    // 添加全局方法或者属性
    Vue.myGlobalMethod = function () { }
    // 添加全局指令
    Vue.directive('focus', {
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    })
    // 添加混入
    Vue.mixin({
      data() {
        return {
          curId: -1,
          fileUploadHeaders: {

          },
          pagePermission: (this.$route && this.$route.meta && this.$route.meta.permission) ? this.$route.meta.permission : '',
          organizeMix:[],
          //混入小区列表
          communitiesMix:[]
        }
      },
      // 添加到mixin中的任何内容将被注入到所有组件中。
      // 在这个例子中， mounted() 方法将在组件被挂载到DOM后调用
      methods: {
        // 拼接图片
    getItemPhoto(id) {
      var url = this.global.baseUrlImage + "avatar/" + id;
      return url;
    },
        setPageInfo: function (name, url) {
          var link = document.querySelector("link[rel*='icon']") || document.createElement('link')
          link.type = 'image/vnd.microsoft.icon'
          link.rel = 'shortcut icon'
          link.href = url
          document.getElementsByTagName('head')[0].appendChild(link)
          var title = document.querySelector('title') || document.createElement('title')
          title.innerText = name
          this.$store.commit('setSystemName', name)
          this.$store.commit('setSystemIconUrl', url)
        },
        cellEnter: function (row) {
          this.curId = row.id
        },
        cellLeave: function (row) {
          this.curId = -1
        },
        hasPerm: function (perms) {
          // let hasPermission = false
          let permissions = store.state.user.perms.data || [] ;
          // let permissions = this.$store.state.user.perms || []
          // for (let i = 0, len = permissions.length; i < len; i++) {
          //   if (permissions[i].name === perms) {
          //     hasPermission = true
          //     break
          //   }
          // }
          // return hasPermission
          return Array.isArray(permissions) && new Set(permissions).has(perms);
        },
        getOrganizeMix() {
          let that = this;
          return new Promise(
            resolve => {
              if (!store.state.organize.organize.length) {
                that.$api.wxNotic.sys_party_organize().then((res) => {
                  if(res.code===0){
                    store.commit('updateOrga', res.data)
                  }
                  resolve(store.state.organize.organize);
                })
              } else {
                resolve(store.state.organize.organize);
              }
            }
          )
        },
        getCommunitiesMix(){
          let that = this;
          return new Promise(
            resolve => {
              if (!store.state.organize.communities.length) {
                that.$api.three.communityList().then((res) => {
                  if(res.code===0){
                    console.log(res.data)
                    store.commit('updateCom', res.data)
                  }
                  resolve(store.state.organize.communities);
                })
              } else {
                resolve(store.state.organize.communities);
              }
            }
          )
        }
      },
      created() {
        if (sessionStorage) {
          this.fileUploadHeaders.Authorization = sessionStorage.getItem('token')
        }
      },
      beforeRouteLeave(to, from, next) {
        // this.scrollY = window.scrollY
        next()
      },
      beforeRounteEnter(to, from, next) {
        next(vm => {
          window.scroll(0, vm.scrollY)
        })
      }
    })
    // 添加实例方法
    // Vue.prototype.$xxx = function () {}
    // 注册全局组件
    Vue.component()
  }
}


Vue.use(plugin)



// WEBPACK FOOTER //
// ./src/utils/plugin.js